export default "__VITE_ASSET__477791df__"